import React from 'react'
import { GoogleLogin, FaceBookLogin } from '.';

const SocialLogin = ({ setSocialSignInData }) => {
    return (
        <div className="grid gap-2">
            <div className="g-col-6">
                <GoogleLogin 
                    setSocialSignInData = { setSocialSignInData }
                />
            </div>
            <div className="g-col-6">
                <FaceBookLogin
                    setSocialSignInData = { setSocialSignInData }
                />
            </div>
        </div>
    )
}

export default SocialLogin